<template>
  <div
    :class="$vuetify.breakpoint.mobile ? 'tab-content-card--mobile' : 'tab-content-card'"
  >
    <!------------------Title and buttons---------------------------------------->
    <v-card-title
      v-if="showComponentHeader &&  (config.title || config.showBackButton)"
      class="v-card-title"
    >
      <v-row>
        <v-col
          style="align-items: center;"
          class="d-flex justify-start align-middle"
        >
          <!--      Back button-->
          <universal-button
            v-if="config.showBackButton && config.showBackButton.uiViewName"
            type="back"
            class="mr-2"
            @click="onBack"
          />

          <!--      Tab card title-->
          <span
            :class="$vuetify.breakpoint.mobile ? 'v-card-title-text--mobile' : 'v-card-title-text'"
          >
        {{ config && config.title ? config.title : '' }}
      </span>
        </v-col>
        <v-col
          class="d-flex justify-end align-middle"
        >
          <!--          Additional buttons-->
          <template
            v-if="canShowAdditionalButtons()"
          >
            <template
              v-for="(button, buttonIndex) in config.additional_buttons"
            >
              <div
                v-if="canShowAdditionalButton(button)"
                :key="buttonIndex"
                :style="{ cursor: permissions && !permissions.canEdit ? 'not-allowed' : 'default' }"
              >
                <universal-button
                  :type="button && button.type ? button.type : 'base'"
                  :prepend-icon="button && button.prependIcon ? button.prependIcon : ''"
                  :label="button && button.label && !$vuetify.breakpoint.mobile ? button.label : ''"
                  :disabled="permissions && !permissions.canEdit"
                  class="mr-2"
                  @click="callCallback(button)"
                />
              </div>
            </template>
          </template>

          <!--          Edit buttons-->
          <div
            v-if="config.showButtons && !$vuetify.breakpoint.mobile"
          >
            <div
              :style="{ cursor: permissions && !permissions.canEdit ? 'not-allowed' : 'default' }"
            >
              <universal-button
                v-if="!edit && !createMode"
                type="edit"
                :disabled="permissions && !permissions.canEdit"
                @click="editClicked"
              />
            </div>

            <universal-button
              v-if="edit || createMode"
              class="mr-2"
              type="cancel"
              @click="cancelTab"
            />

            <universal-button
              v-if="edit || createMode"
              @click="saveTab"
            />
          </div>
        </v-col>
      </v-row>
    </v-card-title>

    <!------------------Subtitle---------------------------------------->
    <v-card-title
      v-if="showComponentHeader && config.subTitle"
      class="v-card-subTitle"
    >
      <span
        :class="$vuetify.breakpoint.mobile ? 'v-card-subTitle-text--mobile' : 'v-card-subTitle-text'"
      >
        {{ config.subTitle }}
      </span>
    </v-card-title>

    <div
      :class="getVCardTextClasses()"
    >
      <div
        ref="container"
        class="logDataWrapper"
      >
        <template
          v-for="(field, fieldIndex) in dynamicFields"
        >
          <div
            v-if="canShowField(field, 'text')"
            :key="fieldIndex"
            :style="fieldWrapperStyle"
            @dblclick="unlockFieldsOnDblClick(field)"
          >
            <template
              v-if="!isFieldStatic(field)"
            >
              <text-field
                v-model="modifiedFormData[config.dataKey][fieldIndex - staticFieldsLength]"
                :field="field"
                :update-data="updateData"
                :update-validation-errors="updateValidationErrors"
                :validation-errors="validationErrors"
                :form-data="modifiedFormData"
                :disabled="!edit || !field.editable"
                @clear-validation-errors="$emit('clear-validation-errors', field.key)"
              />

<!--              Remove button-->
              <v-col
                v-if="edit && field.editable"
                cols="2"
                class="remove-btn-col"
                :class="getRemoveButtonClass(fieldIndex - staticFieldsLength, field)"
              >
                <universal-button
                  type="delete-icon"
                  :ripple="false"
                  text
                  @click="removeDynamicField(fieldIndex - staticFieldsLength)"
                />
              </v-col>
            </template>

            <template
              v-else
            >
              <text-field
                v-model="modifiedFormData[field.key]"
                :field="field"
                :update-data="updateData"
                :update-validation-errors="updateValidationErrors"
                :validation-errors="validationErrors"
                :form-data="modifiedFormData"
                :disabled="!edit || !field.editable"
                @clear-validation-errors="$emit('clear-validation-errors', field.key)"
              />
            </template>
          </div>
          <div
            v-else-if="canShowField(field, 'autocomplete')"
            :key="fieldIndex"
            :style="fieldWrapperStyle"
            @dblclick="unlockFieldsOnDblClick(field)"
          >
            <template
              v-if="!isFieldStatic(field)"
            >
              <div
                class="dynamic-field-wrapper"
                :class="edit && field.editable ? 'dynamic-field-wrapper-without-flex-column' : ''"
              >
                <v-row>
                  <v-col
                    :cols="(edit || createMode) && field.editable ? 10 : 12"
                  >
                    <autocomplete-field
                      v-model="modifiedFormData[config.dataKey][fieldIndex - staticFieldsLength]"
                      :field="field"
                      :items="field.items ? field.items : {}"
                      :options="field.autocomplete_options ? field.autocomplete_options : {}"
                      :validation-errors="validationErrors"
                      :update-data="updateData"
                      :update-validation-errors="updateValidationErrors"
                      :collection-key="config.dataKey"
                      :collection-index="fieldIndex - staticFieldsLength"
                      :clearable="field.clearable !== undefined ? field.clearable : false"
                      :disabled="(!edit && !createMode) || !field.editable"
                      @clear-validation-errors="$emit('clear-validation-errors', field.key)"
                    />
                  </v-col>

<!--                  Remove button-->
                  <v-col
                    v-if="(edit || createMode) && field.editable"
                    cols="2"
                    class="remove-btn-col"
                    :class="getRemoveButtonClass(fieldIndex - staticFieldsLength, field)"
                  >
                    <universal-button
                      type="delete-icon"
                      :ripple="false"
                      text
                      @click="removeDynamicField(fieldIndex - staticFieldsLength)"
                    />
                  </v-col>
                </v-row>
              </div>
            </template>
            <template
              v-else
            >
              <autocomplete-field
                v-model="modifiedFormData[fieldIndex]"
                :field="field"
                :items="initialAutocompletes"
                :options="field.autocomplete_options ? field.autocomplete_options : {}"
                :validation-errors="validationErrors"
                :update-data="updateData"
                :update-validation-errors="updateValidationErrors"
                :clearable="field.clearable !== undefined ? field.clearable : false"
                :disabled="!edit || !field.editable"
                @clear-validation-errors="$emit('clear-validation-errors', field.key)"
              />
            </template>
          </div>
        </template>
<!--        Add new field button-->
        <div
          style="align-content: end; padding: 10px;"
          @dblclick="unlockFieldsOnDblClick()"
        >
          <universal-button
            type="new"
            :label="$t('base.add_new_field')"
            :disabled="!edit && !createMode"
            @click="addNewField"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnsContent from './ColumnsContent.vue'
import AutocompleteField from '../fields/AutocompleteField.vue'
import TextField from '../fields/TextField.vue'
import { setEdit } from '../../common/content-shared-events'
import { store } from '@/global/store'
import { cloneDeep } from 'lodash'

const DEFAULT_STATIC_FIELDS_LENGTH = 0
const DEFAULT_CONTAINER_WIDTH = 0
export default {
  name: 'dynamicCreatedFields',

  components: {
    TextField,
    AutocompleteField
  },

  // Extend ColumnsContent component for accessing shared props
  // Avoiding duplicate props declarations
  mixins: [
    ColumnsContent
  ],

  emits: [
    'clear-validation-errors'
  ],

  data () {
    return {
      dynamicFields: [],
      addNewFieldsCnt: 0,
      containerWidth: 0
    }
  },

  watch: {
    // ******* STARTING POINT OF THIS COMPONENT *******
    // From this watcher dynamic fields will be generated
    // Fields are generated from passed data - dynamically
    // Field template should be defined in config, so we can know which type of dynamic field we should generate
    modifiedFormData: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val && this.config && this.config.dataKey && val[this.config.dataKey] && val[this.config.dataKey].length) {
          // ----- DYNAMIC FIELDS GENERATION FROM DATA -----
          this.dynamicFields = val[this.config.dataKey].map(item => {
            // Create a deep copy of the field template to avoid modifying the original
            const fieldTemplate = cloneDeep(this.config.dynamicFieldTemplate)

            // Use the existing field config if available; otherwise, use the template
            const newField = item?.field ? { ...item.field } : { ...fieldTemplate, ...item }

            // If the field is an autocomplete type, ensure it has a `data` array and add the item
            if (!item?.field && fieldTemplate.type === 'autocomplete') {
              fieldTemplate.items ??= {}
              fieldTemplate.items.data ??= []
              fieldTemplate.items.data.push(item)
            }

            return newField
          })

          // ----- MERGING DYNAMIC AND STATIC FIELDS (if exist) -----
          // Map static fields and push them at the beginning of fields array
          if (this.config.fields && this.staticFieldsLength) {
            // Add static: true to static field config to be able to differentiate them in template generation
            // Static fields do not have 'delete' button
            this.config.fields = this.config.fields.map(field => ({
              ...field,
              static: true
            }))

            // Merge static and dynamic fields into one array
            this.dynamicFields = [
              ...this.config.fields,
              ...this.dynamicFields
            ]
          }
        }
        // If there is no data from which we can make fields and if there is only static fields
        else if (val && this.config && this.config.dataKey && (!val[this.config.dataKey] || !val[this.config.dataKey].length) && this.config.fields && this.staticFieldsLength) {
          this.config.fields = this.config.fields.map(field => ({
            ...field,
            static: true
          }))
          this.dynamicFields = [...this.config.fields]
        }
      }
    },
    edit: {
      immediate: true,
      handler () {
        this.addNewFieldsCnt = 0 // Track number of added dynamic fields
      }
    }
  },

  computed: {
    staticFieldsLength () {
      return this.config?.fields?.length ?? DEFAULT_STATIC_FIELDS_LENGTH
    },

    fieldWrapperStyle () {
      let style = {
        padding: '10px'
      }

      if (!this.$vuetify.breakpoint.mobile) {
        style = {
          ...style,
          minWidth: (this.containerWidth / this.config.columnsCount) + 'px',
          width: ''
        }
      }
      else {
        style = {
          ...style,
          minWidth: 'unset',
          width: '100%'
        }
      }

      return style
    }
  },

  mounted () {
    this.updateContainerWidth()
    // Keep container width updated during window resize
    window.addEventListener('resize', this.updateContainerWidth)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.updateContainerWidth)
  },

  methods: {
    updateContainerWidth () {
      this.containerWidth = this.$refs.container ? this.$refs.container.clientWidth : DEFAULT_CONTAINER_WIDTH
    },

    getRemoveButtonClass (index, field) {
      const { dataKey } = this.config || null
      const { key } = field || null
      const formatedKey = dataKey + '.' + index + '.' + key
      let classes = ''

      if (formatedKey && this.validationErrors && this.validationErrors[formatedKey] && this.validationErrors[formatedKey].length) {
        classes += 'remove-btn-col-error'
      }

      return classes
    },

    isFieldStatic (field) {
      return field.static !== undefined && field.static === true
    },

    isFieldEditable (field) {
      const { key, editable } = field || {}

      if (typeof key !== 'string' || !key) {
        return false
      }

      const fieldConfig = this.fieldsConfig[key]

      if (!editable) {
        return false
      }

      return fieldConfig && typeof fieldConfig.editable !== 'undefined' ? fieldConfig.editable : true
    },

    canShowField (field, fieldType = null) {
      const { type, key, initialValue, visible } = field || {}
      let visibleValue = visible

      // Set initial field value
      if (initialValue && key && this.modifiedFormData[key] === undefined) {
        let initialValueModified = initialValue

        if (typeof initialValue === 'function') {
          initialValueModified = initialValue(this)
        }

        this.$set(this.modifiedFormData, key, initialValueModified)
      }

      if (visible && typeof visible === 'function') {
        visibleValue = visible(this)
      }

      return !!fieldType && typeof key === 'string' && key && (!type || type === fieldType) && visibleValue
    },

    unlockFieldsOnDblClick (field) {
      if (this.permissions && !this.permissions.canEdit) {
        return
      }

      if (!field) {
        setEdit(this, true)
        return
      }

      if (this.isFieldEditable(field)) {
        setEdit(this, true)
      }
    },

    removeDynamicField (index) {
      // Remove field from form data
      this.modifiedFormData[this.config.dataKey].splice(index, 1)

      // Decrease fields counter on field delete
      if (this.addNewFieldsCnt > 0) {
        this.addNewFieldsCnt--
      }
    },

    addNewField () {
      const { addMaximumLimit } = this.config || Infinity

      if (this.addNewFieldsCnt === addMaximumLimit) {
        store.dispatch('base/notifications/push', this.$t('base.maximum_limit_adding_field_reached').replace(':limit', addMaximumLimit))
        return
      }

      // If there is no data, create new array instance
      if (this.config.dataKey && !this.modifiedFormData[this.config.dataKey]) {
        this.$set(this.modifiedFormData, this.config.dataKey, [])
      }

      // Push a new field to form data
      this.modifiedFormData[this.config.dataKey].push({
        field: { ...this.config.dynamicFieldTemplate }
      })

      // Update new fields counter
      this.addNewFieldsCnt++
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content-card--mobile {
  width: 100%;
  margin: 0 !important;
}

.tab-content-card > *:last-child {
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  margin-bottom: 10px;
}

.v-card-title {
  font-family: 'Satoshi', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin-top: 1%;
}

.v-card-subTitle {
  font-family: 'Satoshi', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  padding: 10px 0 10px 16px;
}

.v-card-title-text {
  font-family: 'Satoshi', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.v-card-title-text--mobile {
  padding: 0 16px;
  font-family: 'Satoshi', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.v-card-subTitle-text {
  font-family: 'Satoshi', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.v-card-subTitle-text--mobile {
  padding: 0 16px;
  font-family: 'Satoshi', sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #111827;
}

.v-card-text {
  padding: 6px;
  margin: 0 15px;
}

.v-card-text--mobile {
  overflow: hidden;
  padding: 16px;
  margin-left: 1%;
  margin-right: 1%;
  border: unset !important;
}

.v-card-text-bordered {
  border: 1px solid #E5E7EB;
  border-radius: 16px;
}

.v-card-text-not-bordered {
  padding: 0 5px !important;
}

.dynamic-field-wrapper {
  display: flex;
  flex-direction: column;
}

.dynamic-field-wrapper-without-flex-column {
  flex-direction: unset !important;
}

.remove-btn-col {
  align-content: end;
  padding-left: 0;
  padding-bottom: 20px;
}

.remove-btn-col-error {
  padding-bottom: 50px;
}

.logDataWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

::v-deep {
  .v-text-field__details {
    padding: 5px 0 !important;
  }
}
</style>
